import LogoText from "src/Components/LogoText/LogoText";
import { IClinicInfo } from "src/Utils/Hooks/GetClinicInfo/useGetClinicInfo";
import { MailIcon, PhoneIcon, WeChatIcon, FacebookIcon, InstagramIcon, OtherChannelIcon } from "src/SharedComponents/Icons/Icons";
import { useMemo } from "react";

const channelIconMap: Record<string, React.ReactNode> = {
    wechat: <WeChatIcon />,
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
    other: <OtherChannelIcon />,
};

interface IClinicSupportInfoParams {
    clinicDetails: IClinicInfo;
}
const ClinicSupportInfo: React.FC<IClinicSupportInfoParams> = ({ clinicDetails }) => {
    const { show, showChannel } = useMemo(() => {
        const detail = clinicDetails?.supportContactDetail;
        // WhatsApp is not an allowed support channel, so hide it even if a distributor still has one saved.
        const showChannel = detail?.supportChannelType?.toLocaleLowerCase() !== 'whatsapp';
        const show = detail?.contactNumber || detail?.email ||
            (showChannel && (detail?.supportChannelType || detail?.supportChannel));
        return { show, showChannel };
    }, [clinicDetails?.supportContactDetail]);
    const channelIcon = channelIconMap[clinicDetails.supportContactDetail?.supportChannelType?.toLocaleLowerCase() ?? ''] ?? <OtherChannelIcon />;
    return (
        <>
            {show &&
                <>
                    <div className="row">
                        <div className="mb-2 col-9">
                            <b>Support Contact</b>
                        </div>
                    </div>
                    {clinicDetails.supportContactDetail?.email && <LogoText logoElement={<MailIcon />} text={clinicDetails.supportContactDetail?.email} /> }
                    {clinicDetails.supportContactDetail?.contactNumber && <LogoText logoElement={<PhoneIcon />} text={clinicDetails.supportContactDetail?.contactNumber} /> }
                    {showChannel && clinicDetails.supportContactDetail?.supportChannel && <LogoText logoElement={channelIcon} text={clinicDetails.supportContactDetail?.supportChannel} />}
                </>}
        </>)
}

export default ClinicSupportInfo;
